import {useMutation, useQueryClient} from "@tanstack/react-query";
import {message} from "antd";
import {useClientV2} from "../../../../utils/hooks";
import type {UpdateSubscriptionTiersRequestBody} from "../tiers/types";
import {formatTierMutationError} from "../tiers/format-tier-mutation-error";
import {invalidateSubscriptionAfterTierChange} from "../tiers/invalidate-after-tier-change";

export const useUpdateSubscriptionTiersApi = () => {
  const queryClient = useQueryClient();
  const client = useClientV2();

  return useMutation({
    mutationFn: async ({
      subscriptionId,
      body,
    }: {
      subscriptionId: number;
      body: UpdateSubscriptionTiersRequestBody;
    }) => {
      return client(`subscriptions/${subscriptionId}/tiers`, {
        method: "PATCH",
        data: body,
      });
    },
    onError: (error: unknown) => {
      message.error(formatTierMutationError(error));
    },
    onSettled: (_, __, {subscriptionId}) => {
      invalidateSubscriptionAfterTierChange(queryClient, subscriptionId);
    },
  });
};
